import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import GalleryStrip from "@/components/GalleryStrip";
import BookAssessmentDialog from "@/components/BookAssessmentDialog";
import { EnquiryContext } from "@/lib/enquiry-context";
import { scrollToHash } from "@/lib/scroll";

export default function Layout() {
  const [bookOpen, setBookOpen] = useState(false);
  const [bookType, setBookType] = useState("assessment");
  const location = useLocation();

  const openBook = (type = "assessment") => {
    setBookType(type);
    setBookOpen(true);
  };

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => scrollToHash(location.hash), 350);
    } else {
      window.__lenis?.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <EnquiryContext.Provider value={{ openBook }}>
      <Navigation />
      <Outlet />
      {!location.pathname.startsWith("/admin") && <GalleryStrip />}
      <Footer />
      <BookAssessmentDialog open={bookOpen} onOpenChange={setBookOpen} type={bookType} />
    </EnquiryContext.Provider>
  );
}
